<template>
  <v-app id="inspire">
    <v-app-bar app v-if="authenticated">
      <v-btn icon @click="home">
        <svg
          width="48px"
          height="48px"
          viewBox="0 0 338 414"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
        >
          <path
            d="M303.189,0C322.037,0 337.338,15.302 337.338,34.149L337.338,378.962C337.338,397.81 322.037,413.112 303.189,413.112L34.149,413.112C15.302,413.112 0,397.81 0,378.962L0,34.149C0,15.302 15.301,0 34.149,0L303.189,0ZM206.03,297.781L190.655,294.481L195.628,279.075L183.618,268.219L195.628,257.362L190.655,241.956L206.484,238.559L209.881,222.73L225.288,227.703L236.144,215.693L247,227.703L262.406,222.73L265.803,238.559L281.632,241.956L276.659,257.362L288.669,268.219L276.659,279.075L281.632,294.481L266.291,297.773L284.285,364.928L268.184,358.611L257.239,372.175L241.786,314.502L236.144,320.744L230.529,314.532L215.083,372.175L204.298,358.653L188.037,364.928L206.03,297.781ZM236.144,241.149C251.084,241.149 263.213,253.279 263.213,268.219C263.213,283.159 251.084,295.288 236.144,295.288C221.204,295.288 209.074,283.159 209.074,268.219C209.074,253.279 221.204,241.149 236.144,241.149ZM236.144,251.873C245.165,251.873 252.489,259.197 252.489,268.219C252.489,277.24 245.165,284.564 236.144,284.564C227.122,284.564 219.798,277.24 219.798,268.219C219.798,259.197 227.122,251.873 236.144,251.873ZM199.5,161.998C202.812,161.997 205.5,159.309 205.5,155.998L205.5,143.998C205.5,140.686 202.812,137.998 199.5,137.998L54.669,137.998C51.358,137.998 48.669,140.686 48.669,143.998L48.669,155.998C48.669,159.309 51.358,161.998 54.669,161.998L199.5,161.998ZM282.669,118.022C285.981,118.021 288.669,115.333 288.669,112.022L288.669,100.022C288.669,96.711 285.981,94.022 282.669,94.022L54.669,94.022C51.358,94.022 48.669,96.711 48.669,100.022L48.669,112.022C48.669,115.334 51.358,118.022 54.669,118.022L282.669,118.022ZM282.669,74.011C285.981,74.01 288.669,71.322 288.669,68.011L288.669,56.011C288.669,52.699 285.981,50.011 282.669,50.011L54.669,50.011C51.358,50.011 48.669,52.699 48.669,56.011L48.669,68.011C48.669,71.322 51.358,74.011 54.669,74.011L282.669,74.011Z"
            style="fill:#1976d2;"
          />
        </svg>
      </v-btn>
      <v-toolbar-title>Partner-Lizenz-Portal</v-toolbar-title>
      <v-btn @click="home" text>Startseite</v-btn>
      <v-btn @click="profile" text>Profil</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="logout" text>{{username + ' abmelden'}}</v-btn>
      <v-progress-linear :active="loading" indeterminate absolute bottom></v-progress-linear>
    </v-app-bar>

    <v-main :class="{'px-0': $vuetify.breakpoint.xsOnly }">
      <router-view></router-view>
    </v-main>
    <v-footer v-if="authenticated" class="justify-center">
      <a class="mr-2" href="tel:0431-55680681">0431-55680681</a>
      <a href="mailto:bestellung@t2med.de">bestellung@t2med.de</a>
    </v-footer>
    <div style="position: fixed;width:100%;margin-top:2em;z-index:10;">
      <v-layout align-center justify-center>
        <v-flex xs10 sm8 md8 lg8 xl8>
          <div v-for="error in errors" :key="error.id">
            <v-alert color="error" dark dense>
              <v-layout align-center wrap>
                <v-flex xs11>
                  <div v-for="message in error.errors" :key="message">{{message}}</div>
                </v-flex>
                <v-flex xs1>
                  <v-btn @click="removeError(error.id)" icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-alert>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </v-app>
</template>
<style lang="sass">
  @import '../node_modules/typeface-roboto/index.css'
</style>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      errors: state => state.errors,
      authenticated: state => state.authenticated,
      username: state => state.username,
      loading: state => state.loading
    })
  },
  updated: function() {
    if (this.$route.query.name === undefined) {
      this.title = this.$route.meta.title;
    } else {
      this.title = this.$route.query.name;
    }
  },
  methods: {
    home: function() {
      this.$router.push("/");
    },
    profile: function() {
      this.$router.push("/profile");
    },
    removeError: function(id) {
      this.$store.commit("removeError", id);
    },
    logout: function() {
      this.$store.dispatch("LogoutEvent");
      this.$socket.sendObj({
        eventID: "logout"
      });
    }
  },
  data: () => ({
    title: ""
  })
};
</script>
